// queries/useGetPaypalTransactions.ts
"use client";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_PAYPAL_TRANSACTIONS } from "api";
import { PayPalTransactionParams, PayPalFetchParams } from "types";

const fetchPayPalTransactions = async ({ queryKey }: PayPalFetchParams) => {
  const [, { page = 1, pageSize = 80, email, user_id, transaction_id }] = queryKey;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    pageSize: pageSize.toString(),
    ...(email && { email: email.replace("email:", "") }),
    ...(user_id && { user_id }),
    ...(transaction_id && { transaction_id: transaction_id.replace("transaction_id:", "") }),
  });

  return fetch(`${GET_PAYPAL_TRANSACTIONS}?${queryParams}`);
};

export const useGetPayPalTransactions = (
  params: PayPalTransactionParams
): UseQueryResult<any, Error> => {
  return useQuery({
    queryKey: ["payPalTransactions", params],
    queryFn: fetchPayPalTransactions,
    staleTime: 5000,
  });
};

export default useGetPayPalTransactions;
